import req from "@/api/config/config";
import { Message } from "element-ui";

export default {

  // 获取分页资讯列表
  pageNews(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/news/page`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },

  // 获取资讯详情
  getNewsDetail(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/news/info/${params.id}`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },

  // 获取分页资源下载列表 
  pageRelatedDownload(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/relatedDownload/page`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },

  // 获取资源下载详情
  getRelatedDownloadDetail(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/relatedDownload/info/${params.id}`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },


  // 获取分页政策下载列表 
  pageLaw(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/policies/page`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },

  // 获取政策详情
  getPoliciesDetail(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/policies/info/${params.id}`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },


  // 获取分页通知公告列表 
  pageNotice(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/notice/page`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },


  // 帮助中心
  helpCenterPage(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/helpCenter/page`,
      method: "post",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },

  // 获取分页通知公告列表 
  helpCenterInfo(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/helpCenter/getHelpCenterInfo/${params.id}`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },


  // 在线沟通发消息
  chatSave(data) {
    return req.service({
      url: `${req.systemIp}/pc/helpCenter/chat/save`,
      method: "post",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      data,
    });
  },

  chatPage(params) {
    return req.service({
      url: `${req.systemIp}/pc/helpCenter/chat/page`,
      method: "get",
      params,
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
    });
  },

  dictionary(params) {
    return req.service({
      url: `${req.systemIp}/system/ext/dictionary-data`,
      method: "get",
      params,
      headers: {
        "BIDDING-SOURCE": "PC",
      },
    });
  },

     // 获取统计数据
  statistics(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/inquiry/statistics`,
      method: "get",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "BIDDING-SOURCE": "/pc/ext",
      },
      params:{...params,supplyType:JSON.parse(localStorage.getItem("userInfo")||"{}").supplyType|| ''},
    });
  },
};
